import { render, staticRenderFns } from "./TemplateSelectForm.vue?vue&type=template&id=71fd7842"
import script from "./TemplateSelectForm.vue?vue&type=script&lang=js"
export * from "./TemplateSelectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports